var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "location_on"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1368_2200",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1368_2200)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "location_on_2",
    d: "M15 15C15.6875 15 16.276 14.7552 16.7656 14.2656C17.2552 13.776 17.5 13.1875 17.5 12.5C17.5 11.8125 17.2552 11.224 16.7656 10.7344C16.276 10.2448 15.6875 10 15 10C14.3125 10 13.724 10.2448 13.2344 10.7344C12.7448 11.224 12.5 11.8125 12.5 12.5C12.5 13.1875 12.7448 13.776 13.2344 14.2656C13.724 14.7552 14.3125 15 15 15ZM15 24.1875C17.5417 21.8542 19.4271 19.7344 20.6563 17.8281C21.8854 15.9219 22.5 14.2292 22.5 12.75C22.5 10.4792 21.776 8.61979 20.3281 7.17188C18.8802 5.72396 17.1042 5 15 5C12.8958 5 11.1198 5.72396 9.67188 7.17188C8.22396 8.61979 7.5 10.4792 7.5 12.75C7.5 14.2292 8.11458 15.9219 9.34375 17.8281C10.5729 19.7344 12.4583 21.8542 15 24.1875ZM15 27.5C11.6458 24.6458 9.14062 21.9948 7.48438 19.5469C5.82812 17.099 5 14.8333 5 12.75C5 9.625 6.00521 7.13542 8.01563 5.28125C10.026 3.42708 12.3542 2.5 15 2.5C17.6458 2.5 19.974 3.42708 21.9844 5.28125C23.9948 7.13542 25 9.625 25 12.75C25 14.8333 24.1719 17.099 22.5156 19.5469C20.8594 21.9948 18.3542 24.6458 15 27.5Z",
    fill: "#747474"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.0fbf13a771b8e4c8272460fb7bd392bf.svg";
export { ForwardRef as ReactComponent };